import { render, staticRenderFns } from "./collection_heart.vue?vue&type=template&id=e8568f72&scoped=true&"
import script from "./collection_heart.vue?vue&type=script&lang=js&"
export * from "./collection_heart.vue?vue&type=script&lang=js&"
import style0 from "./collection_heart.vue?vue&type=style&index=0&id=e8568f72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8568f72",
  null
  
)

export default component.exports